import type { Params } from "react-router-dom";

/**
 * The route pattern a URL matched, rebuilt from its pathname and params, so
 * `/experiments/3f2a…` reads `/experiments/:id`. A splat's segments read `*`.
 */
export const routePattern = (
  pathname: string,
  params: Params<string>
): string => {
  const { "*": splat, ...named } = params;
  const splatSegments = splat ? splat.split("/").length : 0;
  const segments = pathname.split("/");
  const kept = segments.slice(0, segments.length - splatSegments);
  const byValue = new Map(
    Object.entries(named).flatMap(([key, value]) =>
      value === undefined ? [] : [[value, key] as const]
    )
  );
  const pattern = kept.map((segment) => {
    const key = byValue.get(decodeURIComponent(segment));
    return key === undefined ? segment : `:${key}`;
  });
  return splatSegments > 0 ? [...pattern, "*"].join("/") : pattern.join("/");
};
